import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { getModuleUrl } from "../utils/module";
import IconArrowLeft from "../icons/IconArrowLeft";
import IconArrowRight from "../icons/IconArrowRight";
import IconPlay from "../icons/IconPlay";
import IconReturn from "../icons/IconReturn";

function useNavigation(modules) {
  const { guid } = useParams();
  const location = useLocation();
  const [, , , moduleKey, subModuleKey, listingId] =
    location.pathname.split("/");
  let prevModule = undefined;
  let nextModule = undefined;
  const visibleModules = modules.filter((module) => !module.isHidden);
  let module = visibleModules.find((module) => module.key === moduleKey);
  let moduleIndex = visibleModules.findIndex(
    (module) => module.key === moduleKey
  );

  // If we don't find the module, let's see if the sub module key is the top level module.
  if (!module) {
    module = visibleModules.find((module) => module.key === subModuleKey);
    moduleIndex = visibleModules.findIndex(
      (module) => module.key === subModuleKey
    );
  }

  if (module) {
    const visibleSubModules = module.subModules.filter(
      (subModule) => !subModule.isHidden
    );
    const subModuleIndex = visibleSubModules.findIndex((subModule) => {
      return listingId
        ? // Look for the listing key if we have a listing id
          subModule.keyWithListingId === `${subModuleKey}/${listingId}`
        : subModule.key === subModuleKey;
    });

    if (subModuleIndex > -1) {
      // We are at the beginning of the sub modules
      if (subModuleIndex === 0) {
        prevModule = visibleModules[moduleIndex];
        nextModule = visibleSubModules[subModuleIndex + 1];

        if (prevModule) {
          prevModule = {
            ...prevModule,
            icon: <IconReturn />
          };
        }
      }
      // We are not at the beginning or end of the sub modules
      else if (subModuleIndex !== visibleSubModules.length - 1) {
        prevModule = visibleSubModules[subModuleIndex - 1];
        nextModule = visibleSubModules[subModuleIndex + 1];
      }
      // We hit the end of the sub modules
      else if (subModuleIndex === visibleSubModules.length - 1) {
        prevModule = visibleSubModules[subModuleIndex - 1];
        nextModule = visibleModules[moduleIndex];

        if (nextModule) {
          nextModule = {
            ...nextModule,
            icon: <IconReturn />
          };
        }
      }
    } else {
      // Special case for listings that are toggled while viewing them
      if (listingId) {
        const unfilteredSubModuleIndex = module.subModules.findIndex(
          (subModule) => {
            return listingId
              ? // Look for the listing key if we have a listing id
                subModule.key === `${subModuleKey}/${listingId}`
              : subModule.key === subModuleKey;
          }
        );

        // Traverse the array until we don't find a hidden item
        prevModule = module.subModules
          .slice(0, unfilteredSubModuleIndex)
          .reverse()
          .find((subModule) => !subModule.isHidden);

        // Walk the array until we don't find a hidden item
        nextModule = module.subModules
          .slice(unfilteredSubModuleIndex, module.subModules.length)
          .find((subModule) => !subModule.isHidden);

        if (!prevModule) {
          prevModule = visibleModules[moduleIndex];
          prevModule = {
            ...prevModule,
            icon: <IconReturn />
          };
        }

        if (!nextModule) {
          nextModule = visibleModules[moduleIndex];
          nextModule = {
            ...nextModule,
            icon: <IconReturn />
          };
        }
      }
      // If we aren't toggling a listing, show the next step
      else {
        prevModule = visibleModules[moduleIndex - 1];
        nextModule = visibleModules[moduleIndex + 1];
      }

      // Special cases for the first module
      if (!prevModule) {
        prevModule = {
          url: `/live/${guid}`,
          footerTitle: "Home"
        };
      }

      // Special case for the last module
      if (!nextModule) {
        nextModule = {
          url: `/live/${guid}`,
          footerTitle: "Home",
          icon: <IconReturn />
        };
      }
    }
  } else {
    nextModule = visibleModules[moduleIndex + 1];

    if (moduleIndex === -1) {
      if (nextModule) {
        nextModule = {
          ...nextModule,
          footerTitle: "Start Presentation",
          icon: <IconPlay />
        };
      }
    }
  }

  // Attach icons if they are missing
  if (prevModule && !prevModule.icon) {
    prevModule = {
      ...prevModule,
      icon: <IconArrowLeft />
    };
  }

  if (nextModule && !nextModule.icon) {
    nextModule = {
      ...nextModule,
      icon: <IconArrowRight />
    };
  }

  // Modify the links before they go out
  if (prevModule) {
    prevModule = {
      ...prevModule,
      url: getModuleUrl(prevModule)
    };
  }

  if (nextModule) {
    nextModule = {
      ...nextModule,
      url: getModuleUrl(nextModule)
    };
  }

  return {
    prevModule,
    nextModule
  };
}

export default useNavigation;
